module.exports = __webpack_public_path__ + "img/__icon_SZTYWNA ZABUDOWA.3133b41b.svg";